import PreferredDeliveryMethod from './preferredDeliveryMethod';

export default PreferredDeliveryMethod;
